import CompanyInPageBannerRepository from "@/core/infrastructure/repository/company/CompanyInPageBannerRepository"
import hasData from "@/core/domain/specification/hasData"

export default class CompanyInPageBannerService {
    protected companyInPageBannerRepository: CompanyInPageBannerRepository

    constructor() {
        this.companyInPageBannerRepository = new CompanyInPageBannerRepository()
    }

    async process() {
        const { data, totalCount } =
      await this.companyInPageBannerRepository.fetch()

        if (!hasData(totalCount)) {
            throw new TypeError("No data was provided")
        }

        return data
    }
}
